import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'cz-app-error',
  templateUrl: './app-error.component.html',
  styleUrls: ['./app-error.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppErrorComponent { }
